export const Helpers = {
  getAxiosHeadersConfig: () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return config;
  },
  getUrlParameter: (name) => {
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
  isSafari: () => {
    // @ts-ignore
    if (navigator?.userAgentData?.brands) {
      // @ts-ignore
      return navigator.userAgentData.brands.some((brand) =>
        brand.brand.toLowerCase().includes('safari')
      );
    }
    // NOTE: If navigator.userAgentData is not available, use we use fallback
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },
  isEmail: (text) => {
    // NOTE: we do not support non english characters
    const re = /^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi;

    return String(text).toLowerCase().match(re);
  },
  // TODO: Make logic to be individual per each country
  isPhoneNumberValidSpecialCases: (phoneNumber) => {
    const JordanRegExp1 = /^00\d{3}\d{3}$/; // 00 xxx xxx
    const JordanRegExp2 = /^0[1-9](?!7)(?!9)\d{3}\d{3}$/; // 0x xxx xxx and first xx must not be 79
    const JordanRegExp3 = /^000\d{2}\d{3}$/; // 00 0xx xxx

    const MoroccoRegExp = /^212\d{9}$/;

    const AlgeriaRegExp = /^213\d{9}$/;

    return (
      JordanRegExp1.test(phoneNumber) ||
      JordanRegExp2.test(phoneNumber) ||
      JordanRegExp3.test(phoneNumber) ||
      MoroccoRegExp.test(phoneNumber) ||
      AlgeriaRegExp.test(phoneNumber)
    );
  },
  // TODO: Make logic to be individual per each country
  isPhoneNumberValidForSpecialOperatorFastLink: (phoneNumber) => {
    const IraqFastLink = /^066\d{3}\d{4}$/;

    return IraqFastLink.test(phoneNumber);
  },
};
